var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"google-map",staticStyle:{"border":"0"},attrs:{"width":"100%","height":_vm.height,"loading":"lazy","allowfullscreen":"","src":_vm.mapSrc()}})}
var staticRenderFns = []

export { render, staticRenderFns }